document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.custom-hero-slider').forEach(function (slider) {

    if (slider.dataset.initialized === 'true') {
      return;
    }

    slider.dataset.initialized = 'true';


    const slides = slider.querySelectorAll('.custom-hero-slide');

    if (!slides.length) {
      return;
    }


    const prevButton = slider.querySelector(
      '.custom-hero-slider__prev'
    );

    const nextButton = slider.querySelector(
      '.custom-hero-slider__next'
    );

    const currentCounter = slider.querySelector(
      '.custom-hero-slider__current'
    );

    const progressBar = slider.querySelector(
      '.custom-hero-slider__progress-bar'
    );


    let currentIndex = 0;

    let autoplayInterval = null;


    const autoplay =
      slider.dataset.autoplay === 'true';

    const speed =
      parseInt(slider.dataset.speed, 10) || 5000;


    function showSlide(index) {

      if (index >= slides.length) {
        index = 0;
      }

      if (index < 0) {
        index = slides.length - 1;
      }


      slides.forEach(function (slide, slideIndex) {

        slide.classList.toggle(
          'is-active',
          slideIndex === index
        );

      });


      currentIndex = index;


      if (currentCounter) {

        currentCounter.textContent =
          currentIndex + 1;

      }


      if (progressBar) {

        const progress =
          ((currentIndex + 1) / slides.length) * 100;

        progressBar.style.width =
          progress + '%';

      }

    }


    function nextSlide() {

      showSlide(currentIndex + 1);

    }


    function prevSlide() {

      showSlide(currentIndex - 1);

    }


    function stopAutoplay() {

      if (autoplayInterval) {

        clearInterval(autoplayInterval);

        autoplayInterval = null;

      }

    }


    function startAutoplay() {

      if (!autoplay || slides.length <= 1) {
        return;
      }

      stopAutoplay();

      autoplayInterval = setInterval(function () {

        nextSlide();

      }, speed);

    }


    if (nextButton) {

      nextButton.addEventListener('click', function () {

        nextSlide();

        startAutoplay();

      });

    }


    if (prevButton) {

      prevButton.addEventListener('click', function () {

        prevSlide();

        startAutoplay();

      });

    }


    /*
     * Pause on desktop hover
     */

    slider.addEventListener('mouseenter', function () {

      stopAutoplay();

    });


    slider.addEventListener('mouseleave', function () {

      startAutoplay();

    });


    /*
     * Mobile swipe
     */

    let touchStartX = 0;
    let touchStartY = 0;

    let touchEndX = 0;
    let touchEndY = 0;


    slider.addEventListener(
      'touchstart',
      function (event) {

        touchStartX =
          event.changedTouches[0].clientX;

        touchStartY =
          event.changedTouches[0].clientY;

      },
      {
        passive: true
      }
    );


    slider.addEventListener(
      'touchend',
      function (event) {

        touchEndX =
          event.changedTouches[0].clientX;

        touchEndY =
          event.changedTouches[0].clientY;


        const differenceX =
          touchStartX - touchEndX;

        const differenceY =
          touchStartY - touchEndY;


        /*
         * Ignore vertical page scroll
         */

        if (
          Math.abs(differenceY) >
          Math.abs(differenceX)
        ) {
          return;
        }


        if (Math.abs(differenceX) < 50) {
          return;
        }


        if (differenceX > 0) {

          nextSlide();

        } else {

          prevSlide();

        }


        startAutoplay();

      },
      {
        passive: true
      }
    );


    /*
     * Keyboard navigation
     */

    slider.setAttribute('tabindex', '0');


    slider.addEventListener('keydown', function (event) {

      if (event.key === 'ArrowRight') {

        nextSlide();

        startAutoplay();

      }


      if (event.key === 'ArrowLeft') {

        prevSlide();

        startAutoplay();

      }

    });


    /*
     * Initial state
     */

    showSlide(0);

    startAutoplay();

  });

});